__webpack_require__.p = "/vs/pokerkamers.nl/wordpress/wp-content/react-app/tournaments/";